interface MetaTagsProps {
  title?: string;
}

const MetaTags = ({ title = " The Relayr" }: MetaTagsProps) => {
  return <title>{title}</title>;
};

export default MetaTags;
